import { Clipboard } from '@angular/cdk/clipboard';
import { Component, Inject, inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { NotificationBarService } from 'src/app/services/notification-bar.service';

interface DisplayOptions {
	header?: string;
	alertText?: string;
	secret: string;
}

@Component({
	selector: 'app-onetime-viewer',
	templateUrl: './onetime-viewer.component.html',
	styleUrls: ['./onetime-viewer.component.scss'],
	standalone: false,
})
export class OnetimeViewerComponent implements OnInit {
	public header: string = '';
	public alertText: string = '';

	private translate = inject(TranslateService);

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: DisplayOptions,
		private dialogRef: MatDialogRef<OnetimeViewerComponent>,
		private clipboard: Clipboard,
		private notificationBarService: NotificationBarService
	) {}

	ngOnInit(): void {
		// Set default values from translations
		this.header = this.translate.instant('shared.onetimeViewer.defaultHeader');
		this.alertText = this.translate.instant('shared.onetimeViewer.defaultAlertText');

		// Override with provided data if available
		if (this.data.header) {
			this.header = this.data.header;
		}
		if (this.data.alertText) {
			this.alertText = this.data.alertText;
		}
	}

	public close() {
		this.dialogRef.close();
	}

	public copyToClipboard(): void {
		this.clipboard.copy(this.data.secret);
		this.notificationBarService.notify('info', this.translate.instant('shared.onetimeViewer.secretCopied'), '');
	}
}
